import { render } from "./ProdutoCadastro.vue?vue&type=template&id=2fbe330c&scoped=true&ts=true"
import script from "./ProdutoCadastro.vue?vue&type=script&lang=ts"
export * from "./ProdutoCadastro.vue?vue&type=script&lang=ts"

import "./ProdutoCadastro.vue?vue&type=style&index=0&id=2fbe330c&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbe330c"]])

export default __exports__